// extracted by mini-css-extract-plugin
export default {"board":"Board_board__waieH","leaderboard":"Board_leaderboard__qhRHM","duration":"Board_duration__oLpxN","active":"Board_active__X1UV4"};